exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header[data-v-83cd9e3a]{display:flex;flex-direction:row;align-items:center}.header>[data-v-83cd9e3a]{flex:auto 0 0}.avatar[data-v-83cd9e3a]{width:42px;height:42px;margin-right:24px}.avatar .empty-avatar[data-v-83cd9e3a],.avatar img[data-v-83cd9e3a]{background:#fff;width:100%;height:100%;border-radius:3px}.label[data-v-83cd9e3a]{color:#829ebb}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-83cd9e3a","scoped":true,"sourceMap":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modules/ModuleOwner.vue
// module id = 532
// module chunks = 0